import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useAuthorizationContext } from 'src/components/authorization';

import axios from './axios';

export interface UsePasswordSiginVariables {
  email: string;
  password: string;
}

export interface UsePasswordSigninData {
  access: string;
  refresh: string;
}

export interface UsePasswordSigninErrorData {
  detail: string;
}

export function usePasswordSignin() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { login } = useAuthorizationContext();

  return useMutation<
    UsePasswordSigninData,
    AxiosError<UsePasswordSigninErrorData>,
    UsePasswordSiginVariables
  >(
    (variables) => {
      const data = {
        ...variables,
        password: btoa(encodeURIComponent(variables.password)),
      };

      return axios
        .post<UsePasswordSigninData>('/posht/ashena/signin/token/', data)
        .then((res) => res.data);
    },
    {
      onError: (error) => {
        if (error.response?.status === 401) {
          enqueueSnackbar(error.response.data.detail, { variant: 'error' });
        } else {
          enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
        }
      },
      onSuccess: (data) => {
        login(data.access, data.refresh);
      },
    },
  );
}
